import { FunctionComponent } from 'react';
import { InputNumber, InputNumberProps } from 'antd';
import { FormField, FormFieldProps } from './form-field';

export const FormInputNumber: FunctionComponent<
  Omit<FormFieldProps, 'render'> & { props?: InputNumberProps }
> = (formFieldProps) => {
  const { onChange: propsOnChange, ...restProps } = formFieldProps.props ?? {};
  return (
    <FormField
      {...formFieldProps}
      render={({ field }) => {
        return (
          <InputNumber
            size="large"
            className="form-field__input-number"
            placeholder={formFieldProps.placeholder}
            {...field}
            {...restProps}
            onChange={(value) => {
              field.onChange(value);
              propsOnChange?.(value);
            }}
          />
        );
      }}
    />
  );
};
